import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UpdateDiagnosticEntryValidationSchema } from '../schemas/updateDiagnosticEntry.schema';
import { unFormatUnknownUnit } from '@/common/utils/unFormatters';

interface UseUpdateMaintenanceDirectiveDiagnosticEntryProps {
  directiveEntryId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    UpdateDiagnosticEntryValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateMaintenanceDirectiveDiagnosticEntry = ({
  directiveEntryId,
  options,
}: UseUpdateMaintenanceDirectiveDiagnosticEntryProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceTransportAutoEntriesComplete'],
    mutationFn: (form) => {
      const payload = {
        technical_response: form.technical_response,
        deadline_to_complete_in_days: form.deadline_to_complete_in_days && unFormatUnknownUnit(form.deadline_to_complete_in_days),
        objectives_attributes: form.objectives_attributes,
      }

      return privateAxios.put(`/maintenance/directive/diagnostic_entries/${directiveEntryId}`, {
        ...payload,
      });
    },
    ...options
  });
}
